import { useEffect, useState } from 'react';
import {
  ButtonPseudo,
  IconPercentage,
  InputText,
  SidePanelRow,
  IconTrash,
} from '@ui/src';
import { useDeleteAmountMutation } from '../../hoc/margins/store/services';
import { MarginAmountItemTypes } from './types';

import cn from './styles.module.css';

const MarginAmountItem = ({
  amount,
  setAmounts,
  amounts,
  index,
  isEditable,
  setValue,
  isCustom,
  marginId,
  marginFeeError,
  currencies,
  currencyFromId,
}: MarginAmountItemTypes) => {
  const [fromAmount, setFromAmount] = useState('');
  const [feePercent, setFeePercent] = useState('');
  const [prevAmount, setPrevAmount] = useState('');

  const [deleteAmount] = useDeleteAmountMutation();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextAmounts = amounts.map((item, valueIndex) => {
      const result = { ...item };

      if (index === valueIndex) {
        if (e.target.name === `fromAmount-${index}`) {
          let value;

          if (
            (e.target.value[0] === '0' &&
              e.target.value[1] &&
              e.target.value[1] !== '.') || // 00 || 01
            e.target.value[0] === '.' || // .000
            Array.from(e.target.value.matchAll(/\./g)).length > 1 || // 11..21.
            e.target.value.split('.')[1]?.length > 12 || // 11.22
            Number(e.target.value) > 9_999_999_999_999_999n
          ) {
            value = prevAmount;
          } else {
            value = e.target.value;
            setPrevAmount(value);
          }

          let inputValue = value?.replace(',', '.');
          inputValue = inputValue?.replace(/[^\d.]/g, '');

          result.fromAmount = Number(inputValue);
          setFromAmount(inputValue);
        } else if (e.target.name === `feePercent-${index}`) {
          const feeValue = e.target.value.replace(',', '.');

          result.feePercent = Number(feeValue);
          setFeePercent(feeValue);
        }
      }

      return result;
    });

    setAmounts(nextAmounts);
    setValue('amounts', nextAmounts);
  };

  const onDeleteAmount = (id: string) => {
    const nextAmounts = amounts.filter((item) => item.id !== id);

    if (!id.includes('amount') && (marginId === 'all' || isCustom)) {
      deleteAmount(id);
    }

    setAmounts(nextAmounts);
    setValue('amounts', nextAmounts);
  };

  useEffect(() => {
    if (amount && !feePercent && !fromAmount) {
      setFeePercent(amount.feePercent.toString());
      setFromAmount(amount.fromAmount.toString());
    }
  }, [amount, feePercent, fromAmount]);

  return (
    <div className={cn.feeRangeRow}>
      <SidePanelRow caption="From Amount">
        <InputText
          placeholder="0.00"
          name={`fromAmount-${index}`}
          value={fromAmount}
          disabled={index === 0 || !isEditable}
          onChange={(e) => {
            onChange({
              // @ts-ignore
              target: {
                name: `fromAmount-${index}`,
                value: e.target.value,
              },
            });
          }}
          currency={currencies?.find((item) => item.id === currencyFromId)}
          amountInput
        />
      </SidePanelRow>
      <SidePanelRow caption="Fee, %">
        <div className={cn.inputSuffixRow}>
          <InputText
            placeholder="0.00"
            name={`feePercent-${index}`}
            value={feePercent}
            onChange={(e) => {
              onChange({
                // @ts-ignore
                target: {
                  name: `feePercent-${index}`,
                  value: e.target.value,
                },
              });
            }}
            disabled={!isEditable}
            error={
              marginFeeError && Number(feePercent).toString() === 'NaN'
                ? marginFeeError
                : ''
            }
          />
          <div className={cn.suffix}>
            <IconPercentage />
          </div>
        </div>
      </SidePanelRow>
      {/* {index > 0 && isEditable && ( */}
      <ButtonPseudo
        className={`${cn.feeRangeRemove} button-white`}
        onClick={() => onDeleteAmount(amount.id as string)}
        icon={<IconTrash />}
      />
      {/* // )} */}
    </div>
  );
};

export default MarginAmountItem;
